import React, { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { PrepFormStep } from '../wizard'
import { badaDefaultProps, badaPropTypes } from '../../../../types'
import { Connection } from '../../../signalr'

const PrepFormPage = ({ props }) => {
  const location = useLocation()

  const focused = useMemo(
    () => !!new URLSearchParams(location.search).get('block-focus'),
    [location]
  )

  useEffect(() => {
    if (!props.wizard.step.five) {
      return () => {}
    }
    const id = props.appointmentId
    const refetch = props.appointment?.refetch
    if (!id || !refetch) {
      return () => {}
    }

    const reconnect = () => {
      refetch().then((data) => {
        const prepData = data?.data?.appointment?.appointmentPreparations
        if (!prepData) {
          return
        }
        props.updateUiState({
          prepData: {
            willBringKitchenImages: prepData.willBringCurrentKitchenImages,
            willBringKitchenSketchImages: prepData.willBringKitchenScetchImages,
            questions: prepData.questions,
          },
        })
      })
    }
    Connection.onReconnect(reconnect)
    return () => {
      Connection.offReconnect(reconnect)
    }
  }, [
    props.wizard.step.five,
    props.appointmentId,
    props.updateUiState,
    props.appointment?.refetch,
  ])

  useEffect(() => {
    if (!props.wizard.step.five) {
      return () => {}
    }
    const id = props.appointmentId
    if (!id) {
      return () => {}
    }

    const update = (prepData) => {
      props.updateUiState({
        prepData: {
          willBringKitchenImages: prepData.willBringCurrentKitchenImages,
          willBringKitchenSketchImages: prepData.willBringKitchenScetchImages,
          questions: prepData.questions,
        },
      })
    }

    Connection.subscribe(id, update)
    return () => {
      Connection.unsubscribe(id, update)
    }
  }, [props.wizard.step.five, props.appointmentId, props.updateUiState])

  return <PrepFormStep {...props} focused={focused} />
}

PrepFormPage.defaultProps = {
  ...badaDefaultProps,
}

PrepFormPage.propTypes = {
  ...badaPropTypes,
}

export default PrepFormPage
